<template>
  <div>
    <nav role="navigation" class="navbar topnavbar">
      <div class="navbar-header">
          <a class="navbar-brand">
            <div class="brand-logo">
                <img src="../assets/calvert-logo.png" alt="Calvert Impact Capital" class="img-responsive" width="120">
            </div>
          </a>
      </div>
    </nav>
    <center class='page'>
      <img src="../assets/img/icon-maintenance.svg" alt="Maintenance" width='300'>
      <p class='title extra-space'>We'll be back soon!</p>
      <p class='text extra-space'>We're currently undergoing maintenance, the site will be online shortly.</p>
      <p class='text'>If you need more help, please contact Calvert Impact Capital at</p>
      <p class='text'>
        <a href="mailto:info@calvertimpact.org" class="hyperlink">info@calvertimpact.org</a> or call us at
        <a href="tel:8002480337" class="hyperlink">800-248-0337</a>.
      </p>
    </center>
  </div>
</template>

<script>
  export default {
    name: 'Maintenance',
  };
</script>

<style scoped>
.page {
  background: #F5F7FA;
  margin-top: 10vh;
}

.title {
  color: #211915;
  font-size: 36px;
  margin-top: 2vh;
}

.extra-space {
  margin-bottom: 2vh;
}

.text {
  color: #211915;
  font-size: 18px;
}
​
.hyperlink{
  color: #00788D;
}
</style>



// WEBPACK FOOTER //
// Maintenance.vue?9d027822